import React from 'react';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  rounded?: string;
}

export default function Skeleton({ width = '100%', height = '100%', rounded = '6px', className = '', ...props }: SkeletonProps) {
  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
    borderRadius: rounded
  };

  return <div className={`skeleton ${className}`} style={style} {...props} />;
}
